    
    import Dialog from '@mui/material/Dialog';
    import DialogActions from '@mui/material/DialogActions';
    import DialogContent from '@mui/material/DialogContent';
    import DialogContentText from '@mui/material/DialogContentText';
    import DialogTitle from '@mui/material/DialogTitle';
    import React, { useState,useEffect} from 'react';
    import {apiUrl} from '../pages/UrlParam';
   

    export default function ImageViewer({path, productopen,setproductopen,filename}) {
         
        useEffect(() => {
            //alert(productopen)
            if(productopen) {
               // productclose(true);
                //GetData();
            }
          
        }, [productopen]);

        const handleClose = () => {
           // productclose(false)
           setproductopen(false);
        }
  
        return( 
            <Dialog
                open={productopen}
                onClose={handleClose}
                maxWidth="md"
            >
                <form  role="form"> 
                
                <DialogContent>
                    <DialogContentText>
                       <h4>{filename}</h4>
                    </DialogContentText>
                    <div className='row mb-6'>
                        <div className='col-lg-12'>
                            <img src={apiUrl + "/" + path} width={"100%"} height={"100%"}></img>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn' onClick={handleClose} type='button'>Close</button>
                </DialogActions>
                </form>
                </Dialog>
        )
    }
    
    